export const DEFAULT_STATE_FORM_IMPORT_MANIFEST = {
    id_shipping_partner: null,
    language: "",
    manifest: "",
};
